import { render, staticRenderFns } from "./groupDetail.vue?vue&type=template&id=af366d2a&"
import script from "./groupDetail.vue?vue&type=script&lang=js&"
export * from "./groupDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports